<template>

  <!-- Courses Admin Start -->
  <div class="section overflow-hidden position-relative min-height" id="wrapper">

    <!-- Page Content Wrapper Start -->
    <div class="page-content-wrapper padding-left-0">
      <div class="container-fluid custom-container">

        <!-- Message Start -->
        <div class="dashboard-head" v-if='user'>
          <div class="message-content">
            <h2>Hello <span class="cap">{{ user.first_name }}! </span></h2>
            <h3>Welcome to your COLREGs Admin Dashboard!</h3>
          </div>
        </div>
        <!-- Message End -->

        <!-- Your Packages Start -->
        <div class="section section-padding mt-n10 padding-top-50">
          <div class="container row gx-10">

            <div class="col-lg-8">
              <!-- Courses Resources Start -->
              <div class="courses-resources user-home widget-information">
                <h4 class="title">Here is what all you can do with your account</h4>

                <!-- Resources Wrapper Start -->
                <div class="resources-wrapper">
                  <div class="row row-cols-xl-4 row-cols-md-3 row-cols-2">
                    <div class="col">

                      <!-- Single Resources Start -->
                      <div class="single-resources">
                        <div class="resources-icon">
                          <router-link to="/dashboard/admin/registered-user-details">
                            <i class="icofont-users-alt-6 dashboard-icon"></i>
                          </router-link>
                        </div>
                        <h5 class="title"><router-link to="/dashboard/admin/registered-user-details">Users</router-link></h5>
                      </div>
                      <!-- Single Resources Start -->

                    </div>
                    <div class="col">

                      <!-- Single Resources Start -->
                      <div class="single-resources">
                        <div class="resources-icon">
                          <router-link to="/dashboard/admin/add-package">
                            <i class="icofont-box dashboard-icon"></i>
                          </router-link>
                        </div>
                        <h5 class="title"><router-link to="/dashboard/admin/add-package">Package Requests</router-link></h5>
                      </div>
                      <!-- Single Resources Start -->

                    </div>
                    <div class="col">

                      <!-- Single Resources Start -->
                      <div class="single-resources">
                        <div class="resources-icon">
                          <router-link to="/dashboard/admin/profile">
                            <i class="icofont-user dashboard-icon"></i>
                          </router-link>
                        </div>
                        <h5 class="title"><router-link to="/dashboard/admin/profile">Profile</router-link></h5>
                      </div>
                      <!-- Single Resources Start -->

                    </div>
                  </div>
                </div>
                <!-- Resources Wrapper End -->

              </div>
              <!-- Courses Resources End -->
            </div>


          </div>
        </div>
        <!-- Packages End -->

      </div>
    </div>
    <!-- Page Content Wrapper End -->
  </div>
    <!-- Courses Admin Start End-->



  <!-- <div class="admin-dashboard">
    <h1>Website Admin Dashboard</h1>
    <section class="test-results">
      <h2>Questions List <button @click="add_question_toggle = !add_question_toggle">Add questions</button>



      </h2>
      <div v-if="add_question_toggle">
        <p>View/Edit Questions</p>
        <Table :data="questions" :columnsToShow="['question', 'options', 'ans', 'complexity', 'created_by']">

        </Table>
      </div>
      <div v-else>
        <AddQuestion />
      </div>

    </section>


    <section class="test-results">
      <h2>Bulk Upload Questions

      </h2>

      <div>
        <input type="file" @change="handleFileUpload" accept=".xlsx" />
        <button @click="submitFile" :disabled="!selectedFile">Upload</button>
      </div>

      <p>{{ bulk_upload_response }}</p>


    </section>

    <section class="data-export">
      <CreatePackage />
    </section>

    <section class="profile">
      <h2>Admin Profile</h2>
      <p>Manage your profile and change your password.</p>
    </section>

    <section class="data-export">
      <h2>Data Export</h2>
      <p>Export all question data in Excel format.</p>
      <button @click="exportData">Export Data</button>
    </section>

    <section class="testimonial-management">
      <h2>Testimonial Management</h2>
      <p>Manage and approve testimonials.</p>
    </section>
  </div> -->
</template>

<script>
// import AddQuestion from './AddQuestion.vue';
// import CreatePackage from './CreatePackageForm.vue';
// import { fetchAllUsers, fetchAllQuestions, bulkUploadQuestions } from '@/services/adminService';
// import Table from '@/components/reusable/Table.vue';
import { getUserDetails } from '@/services/userService';
import { jwtDecode } from "jwt-decode";

// import {AppConfig} from '@/constants';

export default {
  name: 'AdminDashboard',

  components: {
  },


  data() {
    return {
      users: [],
      questions: [],
      add_question_toggle: true,
      selectedFile: null,
      bulk_upload_response: '',
      ques: null,
      token_info: null,
      user: null
    };
  },

  // async created() {
  //   try {
  //     this.users = await fetchAllUsers(); // Fetch users when the component is created
  //     this.questions = await fetchAllQuestions();

  //   } catch (error) {
  //     console.error('Failed to load users:', error);
  //   }
  // },
  async mounted() {
    const decoded = jwtDecode(localStorage.getItem('access_token'));
    this.token_info = decoded;
    // this.ques = AppConfig.API_BASE_URL + '/test/question/67e8458aa956d7bc731cdb6c'
    this.getUserDetail();
  },
  methods: {
    exportData() {
      console.log('Export data clicked');
      // Handle data export functionality
    },

    handleFileUpload(event) {
      this.selectedFile = event.target.files[0];
    },

    // async submitFile() {
    //   this.bulk_upload_response = await bulkUploadQuestions(this.selectedFile);
    // },

    async getUserDetail(){
      this.user = await getUserDetails(this.token_info.email);
    }
  }
};
</script>
